import React from "react";
import Header from '../component/Header';

export default function NotFound({ maskedPhoneNumber, message }) {
    return (
        <>
            <Header phoneNumber={maskedPhoneNumber} />
            <div className="NotFound text-center">
                <h3>{message}</h3>
            </div>
        </>
    );
}